// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8407bffa","455":"bac6ee75","977":"b2f4990b"}[chunkId] + ".chunk.js";
};